import Comp from './Pagination'

export default Comp
